<script>
// import ApiConfig from '@/api/api.config'
import OwnerApi from '@/api/owner';
import VendorApi from '@/api/vendor';
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";

export default {
  name: 'ForgotPassword',
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      portal: 'owner',
      customerName: 'Resort Management System',
      backgroundUrl: '',
      userName: '',
      question: '',
      answer: '',
      isLoading: false,
      loginFail: false,
      apiMessageModal: false,
      apiMessage: '',
      modalImage: '',
      errorMessage: ''
    };
  },
  validations() {
    return {
      userName: {
        required
      },
      answer: {
        required
      },
      question: {
        required
      }
    };
  },
  watch: {
    userName(newValue) {
      const data = JSON.parse(localStorage.getItem('loginSettings'));

      if (data.prefixCode && newValue !== '') {
        switch (data.portal) {
          case 'owner': {
            OwnerApi
              .getSecretQuestion(data.prefixCode, newValue)
              .then(response => {
                if (response.data.result !== null) {
                  this.question = response.data.result;
                } else {
                  this.question = null;
                }
              })
              .catch(error => {
                console.log(error);
              });
            break;
          }
          case 'vendor': {
            VendorApi
              .getSecretQuestion(data.prefixCode, newValue)
              .then(response => {
                if (response.data.result !== null) {
                  this.question = response.data.result;
                } else {
                  this.question = null;
                }
              })
              .catch(error => {
                console.log(error);
              });
            break;
          }
        }
      }
    }
  },
  beforeCreate() {
    const data = JSON.parse(localStorage.getItem('loginSettings'));
    if (data.prefixCode) {
      switch (data.portal) {
        case 'owner': {
          OwnerApi
            .getLoginSetting(data.prefixCode)
            .then(response => {
              const settings = response.data.result;
              settings.prefixCode = data.prefixCode;
              settings.portal = data.portal;
              this.customerName = response.data.result.customerName;
              this.backgroundUrl = response.data.result.loginOptions.backgroundUrl;
              this.portal = data.portal;
              localStorage.setItem('loginSettings', JSON.stringify(settings));
            })
            .catch(error => {
              console.log(error);
            });
          break;
        }
        case 'vendor': {
          VendorApi
            .getLoginSetting(data.prefixCode)
            .then(response => {
              const settings = response.data.result;
              settings.prefixCode = data.prefixCode;
              settings.portal = data.portal;
              this.customerName = response.data.result.customerName;
              this.backgroundUrl = response.data.result.loginOptions.backgroundUrl;
              this.portal = data.portal;
              localStorage.setItem('loginSettings', JSON.stringify(settings));
            })
            .catch(error => {
              console.log(error);
            });
          break;
        }
      }
    }
  },
  methods: {
    successMessage(message) {
      this.modalImage = '/img/success.png';
      this.apiMessage = message;
      this.apiMessageModal = true;
    },
    closeMessage() {
      this.$router.push('/');
    },
    uppercaseValue(e, prop) {
      const start = e.target.selectionStart;
      e.target.value = e.target.value.toUpperCase();
      this.$set(this, prop, e.target.value);
      e.target.setSelectionRange(start, start);
    },
    login(e) {
      e.preventDefault();
      const settings = JSON.parse(localStorage.getItem('loginSettings'));
      const data = {
        unitId: this.userName,
        vendorId: this.userName,
        answer: this.answer,
        prefixCode: settings.prefixCode,
        portal: settings.portal
      };

      if (!this.v$.$invalid) {
        this.isLoading = true;
        switch (settings.portal) {
          case 'owner': {
            OwnerApi
              .resetPassword(data, data.prefixCode, data.unitId)
              .then((response) => {
                if (response.data.success) {
                  this.isLoading = false;
                  this.successMessage('Your password has been reset successfully. Please check your email inbox!');
                }
              }, (error) => {
                this.loginFail = true;
                this.isLoading = false;
                this.errorMessage = error.response.data.detail;
              });
            break;
          }
          case 'vendor': {
            VendorApi
              .resetPassword(data, data.prefixCode, data.vendorId)
              .then((response) => {
                if (response.data.success) {
                  this.isLoading = false;
                  this.successMessage('Your password has been reset successfully. Please check your email inbox!');
                }
              }, (error) => {
                this.loginFail = true;
                this.isLoading = false;
                this.errorMessage = error.response.data.detail;
              });
            break;
          }
        }
      } else {
        this.v$.$touch();
      }
    }
  }
};

</script>

<template lang="pug">
  .login-container(
    v-bind:style="{ background: 'url(' + backgroundUrl + ') center no-repeat' }"
    v-if="portal !== 'reservation'"
  )
    .mb-login-warning(v-if="$helper.isMobile()" v-show="loginFail || v$.userName.$error || v$.answer.$error")
      span(v-if="loginFail") {{errorMessage}}
      span(v-if="v$.userName.$error || v$.answer.$error") Field is required
    form(role="form")
      .header.mb-xl
        h4.company-name.mb {{ customerName.toUpperCase() }}
        p.portal-type(v-if="portal==='owner'") {{ portal | capitalize }} Portal Reset Password
        p.portal-type(v-if="portal==='vendor'")  Cleaning {{ portal | capitalize }} Portal Reset Password
      .form-group.bb(
        :class="{'border-red': v$.userName.$error, 'border-red-mb': v$.userName.$error && $helper.isMobile()}"
      )
        .input-group.align-items-center
          //- .img.flex.align-items-center(v-if="!$helper.isMobile()")
          input.form-control(
            v-if="portal==='vendor'"
            type="text"
            :placeholder="portal + ' ID' | capitalize"
            v-model="userName"
            @input="uppercaseValue($event, 'userName')"
            name="user-name"
          )
          input.form-control(
            v-if="portal==='owner'"
            type="text"
            placeholder="Unit ID"
            v-model="userName"
            @input="uppercaseValue($event, 'userName')"
            name="user-name"
          )
          .mb-element(v-if="$helper.isMobile()")
            .mb-background
            //- .img

      .form-group.bb(
        :class="{'border-red': v$.question.$error, 'border-red-mb': v$.question.$error && $helper.isMobile()}"
      )
        .input-group.align-items-center
          //- .img.flex.align-items-center(v-if="!$helper.isMobile()")
          input.form-control(
            type="text"
            placeholder="Question"
            v-model="question"
            name="question"
            disabled
          )
          .mb-element(v-if="$helper.isMobile()")
            .mb-background(v-if="$helper.isMobile()")
            //- .img
      .form-group.bb(
        :class="{'border-red': v$.answer.$error, 'border-red-mb': v$.answer.$error && $helper.isMobile()}"
      )
        .input-group.align-items-center
          //- .img.flex.align-items-center(v-if="!$helper.isMobile()")
          input.form-control(
            type="text"
            placeholder="Answer"
            v-model="answer"
            name="answer"
          )
          .mb-element(v-if="$helper.isMobile()")
            .mb-background(v-if="$helper.isMobile()")
            //- .img
      .invalid-warning(v-if="!$helper.isMobile()" v-show="loginFail || v$.userName.$error || v$.answer.$error")
        span(v-if="loginFail") {{errorMessage}}
        span(v-if="v$.userName.$error || v$.answer.$error") Field is required
      .form-group.pt-lg.text-center
        button.btn.btn-primary.w-100.login-button.btn-block(
          type="button"
          v-show="!isLoading"
          @click="login($event)"
        )
          span.vertical-middle OK
        .login-button.flex.justify-content-center.align-items-center(v-show="isLoading")
          .ball-spin-fade-loader
            div
            div
            div
            div
            div
            div
            div
            div
          .text-uppercase.ml-xl
            span.vertical-middle Loading
        router-link.btn.button.w-100.btn-secondary.btn-block.mt-sm(
          :to="{name: 'login'}"
        )
          span.vertical-middle BACK
      .footer.text-center.pt-lg
        span Powered by
          a(href="http://resortmanagementsystem.com")  RMS
    b-modal(
      v-model="apiMessageModal"
      :body-class="'p0'"
      :header-class="'modal-small-header p-md'"
      hide-footer
      centered
      @hidden="closeMessage"
    )
      template(slot="modal-title")
        img.mr(:src="modalImage")
        span {{apiMessage}}

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin placeholder {
  ::-webkit-input-placeholder {
    @content
  }
  :-moz-placeholder {
    @content
  }
  ::-moz-placeholder {
    @content
  }
  :-ms-input-placeholder {
    @content
  }
}

.login-container {
  background-color: gray !important;
  background-size: cover;
  position: relative;
  width: 100%;
  height: 100vh;

  .header {
    width: 100%;
    color: #244b8d;
    text-align: center;
    font-family: AvenirLTStd Medium;

    .company-name {
      font-size: 24px;
      line-height: 36px;
    }
  }

  .footer {
    font-size: 13px;
    font-family: AvenirLTStd Medium;
    color: #68727d;
  }

  .bb {
    border-color: #e6eaed;
  }

  .border-red {
    border-color: #f00c17;
  }

  .border-red-mb {
    border: 1px solid #f00c17 !important;
    border-radius: 20px !important;
  }

  .img {
    img {
      width: auto;
      margin: auto;
    }
  }

  form {
    @include placeholder {
      color: #68727d;
      font-family: AvenirLTStd Roman;
    }

    width: 550px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 50px 50px 25px;
    background-color: #fff;
    border-radius: 10px;
    font-size: 15px;
    font-family: AvenirLTStd Roman;

    input {
      display: inline-block;
      width: 95%;
      box-shadow: none;
      border: none;
      color: #32383f;
      font-family: AvenirLTStd Roman;
    }

    .login-button {
      background-color: #244b8d;
      border: none;
      font-size: 15px;
      font-family: AvenirLTStd Medium;
      line-height: 18px;
      vertical-align: middle;
      padding-top: 10px;
      padding-bottom: 10px;
      box-shadow: none;
      border-radius: 5px;
      color: #fff;

      &:hover {
        background-color: #3e5d92;
        box-shadow: none;
      }
    }

    a.btn-secondary {
      border: none;
      font-size: 15px;
      font-family: AvenirLTStd Medium;
      line-height: 18px;
      vertical-align: middle;
      padding-top: 10px;
      padding-bottom: 10px;
      box-shadow: none;
      border-radius: 5px;
      color: #fff;

      &:hover {
        box-shadow: none;
      }
    }

    .input-group {
      .form-control:disabled {
        background-color: transparent;
      }
    }
  }

  @media screen and (max-width: 823px) {
    form {
      @include placeholder {
        color: #32383f;
      }
      background-color: #fff;
      width: calc(100vw - 10px);
      color: #32383f;
      padding: 25px;

      .header {
        color: #244b8d;
      }

      .footer {
        color: #68727d;
      }

      .input-group {
        input {
          width: 100%;
          color: #32383f;
          background-color: transparent;
          height: 40px;
          line-height: 50px;
          padding-left: 60px;
          z-index: 2;
          font-family: AvenirLTStd Medium;
        }

        .mb-element {
          .mb-background {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: #68727d;
            opacity: 0.25;
            top: 0;
            left: 0;
            border-radius: 50px;
            z-index: 1;
          }

          .img {
            position: absolute;
            top: 12px;
            left: 23px;
            z-index: 2;

            img {
              max-width: 75%;
            }
          }
        }
      }

      .form-group {
        border: none;
      }

      .login-button, a.btn-secondary {
        height: 40px;
        border-radius: 50px;
      }
    }
    .mb-login-warning {
      width: calc(100vw - 60px);
      max-width: 350px;
      background-color: #fff;
      color: #f00c17;
      margin: auto;
      padding: 15px;
      font-family: AvenirLTStd Roman;
      z-index: 3;
    }
  }
}
</style>
